<script>
    import {
        selectedField,
        selectedRegion,
        selectedLocality,
        expandAll,
    } from "../Stores";
    import { getSpotsString, nSpotsPerLocality } from "../Utils";
    import IfeSpotsPerRegion from "./IfeSpotsPerRegion.svelte";

    export let spots;
    export let field;
    export let isExpanded = false;
    let isEmpty;

    let year = spots.year;
    let regions = new Set(Object.keys(spots.institutions));

    let n_spots = getSpotsForYear();

    function getSpotsForYear() {
        if (!$selectedRegion && !$selectedLocality) {
            return spots.n_spots;
        }

        //Only show spots for selected region
        if (!$selectedLocality) {
            return spots.institutions[$selectedRegion]?.n_spots ?? 0;
        }

        return nSpotsPerLocality[$selectedLocality][year] ?? 0;
    }

    function selectedLocalityIsInRegion(region) {
        return spots.institutions[region].institutions.some(
            (institution) => institution.locality === $selectedLocality
        );
    }

    function toggleExpand() {
        isExpanded = !isExpanded;
    }

    $: $selectedLocality,
        (() => {
            if ($selectedRegion) {
                isEmpty = !regions.has($selectedRegion);
            } else {
                isEmpty = regions.length === 0;
            }

            isExpanded =
                field === $selectedField ||
                regions.has($selectedRegion) ||
                $expandAll;

            n_spots = getSpotsForYear();
        })();
</script>

<div class="mb-1">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h4
        class="font-bold italic md:text-lg text-sm mt-1 hover:font-extrabold cursor-pointer"
        on:click={toggleExpand}
    >
        {year}
        <span class=" md:text-sm text-xs font-normal not-italic">
            ({n_spots}
            {getSpotsString(n_spots)})
        </span>
    </h4>
    {#if isExpanded}
        {#if isEmpty}
            <p class="text-xs md:text-base ml-2">Sem vagas</p>
        {:else}
            {#each Object.entries(spots.institutions) as [region, institutionsObject]}
                {#if (region === $selectedRegion || !$selectedRegion) && (!$selectedLocality || selectedLocalityIsInRegion(region))}
                    <IfeSpotsPerRegion
                        {year}
                        {region}
                        {field}
                        {institutionsObject}
                    />
                {/if}
            {/each}
        {/if}
    {/if}
</div>
